/* eslint-disable no-debugger */
import React, { useState, useEffect } from "react";
import {
  Col,
  Row,
  message,
  Input,
  Button,
  Form,
  Space,
  Tooltip,
  Drawer,
  Card,
  Modal,
  Upload,
  Image,
  Select,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleFilled,
  PlusOutlined,
} from "@ant-design/icons";
import moment from "moment";
import {
  deleteCompany,
  getPagingCompanys,
  insertCompany,
  updateCompany,
  deleteManyCompany,
  uploadImage,
  deleteImage,
  getAllDepartments,
  createDepartment,
  getManagementCompanyPage,
} from "../../helpers/helper";
import * as url from "../../helpers/url_helper";
import { getImageNameFromURL } from "../../helpers/common";
import DataTable from "../../Components/Common/DataTable";
import imageDefault from "../../assets/images/placeholder.jpg";
import CreateDepartmentModal from "./components/CreateDepartment";
import { Trans, useTranslation } from "react-i18next";

const { Option } = Select;
const { confirm } = Modal;
const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
const CompanysManagement = () => {
  const { t } = useTranslation();
  document.title = t("managerCompany");
  const [form] = Form.useForm();
  const [formSearch] = Form.useForm();
  const [listCompany, setListCompany] = useState([]);
  const [visibleForm, setVisibleForm] = useState(false);
  const [drawerTitle, setDrawerTitle] = useState("");

  const [formDepartment] = Form.useForm();
  const [listDepartment, setListDepartment] = useState([]);
  const [listDepartmentOrigin, setListDepartmentOrigin] = useState([]);
  const [isCreateDepartmentModal, setCreateDepartmentModal] = useState(false);

  //pagination
  const [totalPage, setTotalPage] = useState(1);
  const [indexPage, setPageIndex] = useState(1);
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(10);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loadingDeleteRows, setLoadingDeleteRows] = useState(false);
  //image
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [previewVisible, setPreviewVisible] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [imageDeletes, setImageDeletes] = useState([]);
  const [currentUploadLogo, setCurrentUploadLogo] = useState(null);

  const getAllData = async (_prams, indexPage) => {
    try {
      const params = _prams
        ? _prams
        : {
            pageIndex: indexPage,
            pageSize: pageSize,
            search: "",
          };

      const dataRes = await getPagingCompanys(params);
      setTotalPage(dataRes.totalPages);
      if (!dataRes) {
        message.error(t("requiredPermission"));
        return false;
      }
      const data = convertDataTable(dataRes.data);
      return dataRes?.data ? data : false;
    } catch (error) {
      message.error(t("requiredPermission"));
      setTotalPage(0);
      return [];
    }
  };

  const convertDataTable = (dataArray) => {
    const data =
      dataArray.length > 0 &&
      dataArray.map((item) => {
        return {
          key: item._id,
          companyName: item.companyName,
          companyLogo: item.companyLogo,
          departments: item.departments,
          createdTime: moment(new Date(item.createdTime)).format(
            "DD/MM/YYYY HH:mm"
          ),
        };
      });
    return dataArray ? data : [];
  };

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const data = await getManagementCompanyPage();
        setTotalPage(data.dataPage?.totalPages);

        const dataShowTable = convertDataTable(data.dataPage?.data);
        setListCompany(dataShowTable);

        const dataResDepartment = data.allDepartments.filter(
          (item) => item.company === null
        );
        setListDepartment(dataResDepartment || []);
        setListDepartmentOrigin(dataResDepartment || []);

        setLoading(false);
      } catch (error) {
        message.error(t("requiredPermission"));
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const onFinish = async (data) => {
    try {
      const dataReq = {
        companyName: data.companyName.trim().replace(/\s-\s/g, "-"),
        departments: data.departments,
      };

      if (data.departments && data.departments.length > 0) {
        const newDepartments = await Promise.all(
          data.departments.map(async (item) => {
            if (
              typeof item !== "object" &&
              item?.startsWith("departmentName_")
            ) {
              const dataRes = await createDepartment({
                departmentName: item
                  .split("departmentName_")[1]
                  .replace(/\s-\s/g, "-"),
              });
              if (dataRes.status === 1) {
                return dataRes.data._id;
              }
            } else if (typeof item === "object") {
              return item.value;
            } else {
              return item;
            }
          })
        );
        dataReq.departments = newDepartments;
      }
      if (!data.id) {
        if (currentUploadLogo) {
          const formData = new FormData();
          formData.append("image", currentUploadLogo);
          const responseImage = await uploadImage(formData);
          const { imageName } = responseImage.data;
          dataReq.companyLogo = imageName;
        }
        const dataRes = await insertCompany(dataReq);
        dataRes.status === 1
          ? message.success(t("saveSuccess"))
          : message.error(`${t("saveFail")} ${dataRes.message}`);
        formSearch.resetFields();
        handleRefresh();
      } else {
        const company = listCompany.find((company) => company.key === data.id);

        if (currentUploadLogo && data.companyLogo !== company.companyLogo) {
          const formData = new FormData();
          formData.append("image", currentUploadLogo);
          const responseImage = await uploadImage(formData);
          const { imageName } = responseImage.data;
          dataReq.companyLogo = imageName;
          if (company.companyLogo) {
            await deleteImage(company.companyLogo);
          }
        } else if (data.companyLogo === "") {
          if (company.companyLogo) {
            await deleteImage(company.companyLogo);
          }
        }

        const companyOrigin = company.departments.map((item) => {
          return item._id;
        });

        const equalArray =
          JSON.stringify(data.departments) === JSON.stringify(companyOrigin);
        if (
          equalArray &&
          data.companyLogo === company.companyLogo &&
          data.companyName === company.companyName
        ) {
          message.success(t("dataNotChange"));
          handleCloseDrawer();
        } else {
          const dataRes = await updateCompany(data.id, dataReq);
          dataRes.status === 1
            ? message.success(t("updateSuccess"))
            : message.error(`${t("updateFail")} ${dataRes.message}`);
          for (const imageName of imageDeletes) {
            await deleteImage(imageName);
          }
          handleRefreshData();
        }
      }
      form.resetFields();
      setCurrentUploadLogo(null);
      handleCloseDrawer();
    } catch (error) {
      if (!data.id) message.error(t("permisstionDeniedAction"));
      else message.error(t("permisstionDeniedAction"));
      form.resetFields();
      handleCloseDrawer();
      formSearch.resetFields();
      setCurrentUploadLogo(null);
    }
  };

  const handleResetForm = () => {
    form.resetFields();
    setFileList([]);
    setPreviewImage("");
  };

  const handleRefresh = async () => {
    const _params = {
      pageIndex: 1,
      pageSize: 10,
      search: "",
    };
    const dataRes = await getAllData(_params, indexPage);
    setPageIndex(1);
    setListCompany(dataRes.length > 0 ? dataRes : listCompany);
    formSearch.resetFields();
    let dataResDepartment = await getAllDepartment();
    if (dataResDepartment.length > 0) {
      let dataResDepartment = await getAllDepartment();
      dataResDepartment?.filter((item) => item.company === null);
      setListDepartment(dataResDepartment || []);
      setListDepartmentOrigin(dataResDepartment || []);
    } else {
      setListDepartment(listDepartment);
      setListDepartmentOrigin(listDepartmentOrigin);
    }
  };

  const handleSearch = async () => {
    const dataForm = formSearch.getFieldsValue();
    if (!Object.values(dataForm).some((item) => !!item)) {
      return;
    }
    const params = {
      pageIndex: 1,
      pageSize: pageSize,
      ...getFormSearch(),
    };
    const dataRes = await getAllData(params, 1);
    setListCompany(dataRes.length > 0 ? dataRes : false);
    setPageIndex(1);
  };

  const onPageChange = (page, page_size) => {
    setPageIndex(page);
    setPageSize(page_size);
    onPageChangeAtSearch(page, page_size);
  };

  const onPageChangeAtSearch = async (indexPage, page_size) => {
    setLoading(true);
    const params = {
      pageIndex: indexPage,
      pageSize: page_size,
      ...getFormSearch(),
    };
    const dataRes = await getAllData(params, indexPage);
    setListCompany(dataRes.length > 0 ? dataRes : false);
    setLoading(false);
  };

  const onEdit = (key) => {
    const dataEdit = listCompany.filter((item) => item.key === key);
    form.setFieldsValue({
      companyName: dataEdit[0].companyName,
      companyLogo: dataEdit[0].companyLogo,
      id: dataEdit[0].key,
      departments: dataEdit[0].departments
        ? dataEdit[0].departments.map((value) => {
            return value._id;
          })
        : [],
    });
    setListDepartment(listDepartment.concat(dataEdit[0].departments));

    if (dataEdit[0].companyLogo) {
      setFileList([
        {
          url: `${process.env.REACT_APP_API_URL}${url.API_IMAGE_GET_BY_ID}/${dataEdit[0].companyLogo}`,
          name: dataEdit[0].companyLogo,
        },
      ]);
      setPreviewImage(`${dataEdit[0].companyLogo}`);
    } else {
      setFileList([]);
      setPreviewImage("");
    }
    setPreviewTitle(dataEdit[0].companyLogo);

    setDrawerTitle(t("editCompany"));
    showDrawer();
  };
  const getFormSearch = () => {
    const dataForm = formSearch.getFieldsValue();
    return {
      companyName: dataForm.companyName || "",
    };
  };
  const handleRefreshData = async (index_page) => {
    const _params = {
      pageIndex: index_page ? index_page : indexPage,
      pageSize: pageSize,
      ...getFormSearch(),
    };
    const dataRes = await getAllData(_params);
    setListCompany(dataRes);
    setPageIndex(index_page ? index_page : indexPage);

    let dataResDepartment = await getAllDepartment();
    dataResDepartment.filter((item) => item.company === null);
    setListDepartment(dataResDepartment || []);
    setListDepartmentOrigin(dataResDepartment || []);
  };
  const handleRefreshDataDelete = async (countRemove) => {
    const indexPageNew =
      listCompany.length == countRemove
        ? indexPage === 1
          ? 1
          : indexPage - 1
        : indexPage;
    handleRefreshData(indexPageNew);
  };
  const onDelete = async (key) => {
    try {
      const dataRes = await deleteCompany(key);

      if (dataRes.status === 1) {
        message.success(t("deleteSuccess"));
        handleRefreshDataDelete(1);
      } else {
        message.error(t("deleteFail"));
      }
    } catch (error) {
      message.error(t("permisstionDeniedAction"));
    }
  };

  const showModalConfirmDelete = (record) => {
    confirm({
      title: t("confirmDelete"),
      icon: <ExclamationCircleFilled />,
      okText: t("delete"),
      okType: "danger",
      cancelText: t("cancel"),
      onOk() {
        onDelete(record);
      },
      onCancel() {},
    });
  };

  const validateInput = (_, value) => {
    if (!value || value.trim() === "") {
      return Promise.reject();
    }
    return Promise.resolve();
  };
  const validateSelect = (_, value) => {
    if (!value || value.length === 0) {
      return Promise.reject();
    }
    return Promise.resolve();
  };

  const getAllDepartment = async () => {
    try {
      const dataRes = await getAllDepartments();
      if (!dataRes) {
        message.error(t("requiredPermission"));
        return false;
      }
      const data =
        dataRes.length > 0 && dataRes.filter((item) => item.company === null);

      return dataRes ? data : [];
    } catch (error) {
      message.error(t("requiredPermission"));
      return [];
    }
  };

  const onCreateNewDepartment = async (value) => {
    value.departmentName = value.departmentName.trim();
    const checkDuplicate = listDepartment.some(
      (item) => item.departmentName === value.departmentName
    );
    if (listDepartment.length > 0 && checkDuplicate) {
      message.error(t("departmentNameNotExists"));
      return;
    }
    setListDepartment([
      {
        departmentName: value.departmentName,
        _id: `departmentName_${value.departmentName.trim()}`,
      },
      ...listDepartment,
    ]);

    form.getFieldsValue().departments === undefined
      ? form.setFieldsValue({
          departments: [`departmentName_${value.departmentName.trim()}`],
        })
      : form.setFieldValue({
          departments: form
            .getFieldsValue()
            .departments.push(`departmentName_${value.departmentName.trim()}`),
        });

    setCreateDepartmentModal(false);
    formDepartment.resetFields();
  };

  const columns = [
    {
      title: t("logo"),
      dataIndex: "companyLogo",
      render: (_, record) => {
        var image_avatart = imageDefault;
        if (_) image_avatart = _;
        return (
          <Image
            height={60}
            width={60}
            preview={false}
            src={`${process.env.REACT_APP_API_URL}${url.API_IMAGE_GET_BY_ID}/${record.companyLogo}`}
            fallback={imageDefault}
          />
        );
      },
    },
    {
      title: t("companyName"),
      dataIndex: "companyName",
    },
    {
      title: t("departmentName"),
      dataIndex: "departmentNames",
      render: (_, record) => {
        return record.departments.map((department, index) => (
          <p className="mb-0" style={{ display: "inline-block" }} key={index}>
            {department.departmentName}
            {index < record.departments.length - 1 && (
              <span style={{ paddingLeft: "5px", paddingRight: "5px" }}>|</span>
            )}
          </p>
        ));
      },
    },
    {
      title: t("createdTime"),
      dataIndex: "createdTime",
    },
    {
      title: t("action"),
      dataIndex: "",
      render: (_, record) => (
        <Space>
          <Tooltip title={t("edit")}>
            <Button
              type="primary"
              shape="circle"
              icon={<EditOutlined />}
              size="small"
              onClick={() => onEdit(record.key)}
            />
          </Tooltip>
          <Tooltip title={t("delete")}>
            <Button
              type="danger"
              shape="circle"
              icon={<DeleteOutlined />}
              size="small"
              onClick={() => showModalConfirmDelete(record.key)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const showDrawer = () => {
    setVisibleForm(true);
    setImageDeletes([]);
  };

  const handleNewCompany = () => {
    setDrawerTitle(t("createCompany"));
    showDrawer();
    setFileList([]);
    setCurrentUploadLogo(null);
    form.resetFields();
  };

  const handleCloseDrawer = async () => {
    setDrawerTitle("");
    setVisibleForm(false);
    setFileList([]);
    setPreviewImage("");
    form.resetFields();
    setListDepartment(listDepartmentOrigin);
  };

  const handleDeleteSelectRows = async () => {
    confirm({
      title: (
        <Trans
          i18nKey="deleteConfirmation"
          values={{ count: selectedRowKeys.length }}
        />
      ),
      icon: <ExclamationCircleFilled />,
      okText: t("delete"),
      okType: "danger",
      cancelText: t("cancel"),
      onOk() {
        OnDeleteSelectRows();
      },
      onCancel() {},
    });
  };

  const OnDeleteSelectRows = async () => {
    try {
      setLoadingDeleteRows(true);

      const dataRes = await deleteManyCompany({
        data: { ids: selectedRowKeys },
      });

      if (dataRes.status === 1) {
        message.success(
          <Trans
            i18nKey="deleteManyCompanySuccess"
            values={{ count: dataRes.data.deletedCount }}
          />
        );
        handleRefreshDataDelete(dataRes.data.deletedCount);
      } else {
        message.error(t("deleteFail"));
      }

      setSelectedRowKeys([]);
      setLoadingDeleteRows(false);
    } catch (error) {
      setLoadingDeleteRows(false);
      message.error(t("permisstionDeniedAction"));
    }
  };
  const props = {
    onRemove: async (file) => {
      try {
        const index = fileList.indexOf(file);
        const newFileList = fileList.slice();
        newFileList.splice(index, 1);
        setFileList(newFileList);
        if (file.url) {
          const imageName = getImageNameFromURL(file.url);
          setImageDeletes((prevArray) => [...prevArray, imageName]);
          setPreviewImage("");
        }
      } catch (error) {
        message.error(t("permisstionDeniedAction"));
      }
    },

    beforeUpload: async (file) => {
      setCurrentUploadLogo(file);
      file.onSuccess();
    },
    fileList,
    maxCount: 1,
  };
  const handleCancel = () => setPreviewVisible(false);
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
  };
  const handleChangeImage = ({ fileList: newFileList }) =>
    setFileList(newFileList);
  return (
    <>
      <div className="page-content">
        <Card bordered={false}>
          <Form
            form={formSearch}
            layout="vertical"
            onFinish={handleSearch}
            autoComplete="off"
          >
            <Row gutter={10}>
              <Col span={6}>
                <Form.Item
                  name="companyName"
                  label={t("companyName") + " :"}
                  rules={[
                    {
                      required: false,
                      message: t("validateCompanyName"),
                    },
                    {
                      type: "string",
                      min: 1,
                    },
                  ]}
                >
                  <Input
                    placeholder={t("placeHolderCompanyName")}
                    allowClear={true}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item className="mt-4">
                  <Space>
                    <Button
                      type="primary"
                      htmlType="button"
                      onClick={() => handleSearch()}
                    >
                      {t("search")}
                    </Button>

                    <Button type="primary" onClick={handleNewCompany}>
                      {t("createCompany")}
                    </Button>

                    <Button
                      type="primary"
                      htmlType="button"
                      onClick={() => handleRefresh()}
                    >
                      {t("reload")}
                    </Button>
                    <Button
                      disabled={selectedRowKeys.length === 0}
                      loading={loadingDeleteRows}
                      type="danger"
                      htmlType="button"
                      onClick={() => handleDeleteSelectRows()}
                    >
                      {t("delete")}
                    </Button>
                  </Space>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
        <div>
          <Drawer
            title={drawerTitle}
            placement={"right"}
            width={"60%"}
            onClose={handleCloseDrawer}
            open={visibleForm}
            bodyStyle={{
              paddingBottom: 80,
            }}
            style={{ marginTop: "70px" }}
          >
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              autoComplete="off"
            >
              <Row gutter={10}>
                <Col hidden={true}>
                  <Form.Item name="id" label="Id">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="companyName"
                    label={t("companyName")}
                    rules={[
                      {
                        required: true,
                        validator: validateInput,
                        message: t("validateCompanyName"),
                      },
                      {
                        type: "string",
                        min: 1,
                      },
                    ]}
                    style={{ marginBottom: "22px" }}
                  >
                    <Input
                      placeholder={t("placeHolderCompanyName")}
                      allowClear={true}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Form.Item
                      name="departments"
                      label={t("department")}
                      style={{ width: "80%", marginBottom: "22px" }}
                      rules={[
                        {
                          required: true,
                          validator: validateSelect,
                          message: t("validateSelectDepartment"),
                        },
                      ]}
                    >
                      <Select
                        mode="multiple"
                        placeholder={t("placeHolderSelectCompany")}
                        allowClear
                        showSearch
                        style={{ width: "100%" }}
                      >
                        {listDepartment.length > 0 &&
                          listDepartment.map((item) => {
                            return (
                              <Option key={item._id} value={item._id}>
                                {item.departmentName}
                              </Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                    <Button
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "20%",
                        margin: "3px 0 0 8px",
                      }}
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => setCreateDepartmentModal(true)}
                    >
                      {t("createDepartment")}
                    </Button>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Item name="companyLogo" label={t("logo")} className="">
                    <Space align="start">
                      <Upload
                        {...props}
                        listType="picture-card"
                        onChange={handleChangeImage}
                        onPreview={handlePreview}
                        accept="image/*"
                      >
                        <div>
                          <PlusOutlined />
                          <div
                            style={{
                              marginTop: 8,
                            }}
                          >
                            {t("upload")}
                          </div>
                        </div>
                      </Upload>
                      {previewImage ? (
                        <>
                          <Modal
                            forceRender={true}
                            open={previewVisible}
                            title={previewTitle}
                            footer={null}
                            onCancel={handleCancel}
                          >
                            <img
                              alt={previewTitle}
                              style={{ width: "100%" }}
                              src={previewImage}
                            />
                          </Modal>
                        </>
                      ) : null}
                    </Space>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Item className="">
                    <Space>
                      <Button type="primary" htmlType="submit">
                        {t("save")}
                      </Button>
                      <Button
                        type="primary"
                        htmlType="button"
                        onClick={() => handleResetForm()}
                      >
                        {t("reload")}
                      </Button>
                      <Button type="danger" onClick={handleCloseDrawer}>
                        {t("close")}
                      </Button>
                    </Space>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Drawer>
        </div>
        <DataTable
          listData={listCompany}
          pageSize={pageSize}
          columns={columns}
          indexPage={indexPage}
          totalPage={totalPage}
          onPageChange={onPageChange}
          loading={loading}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
        />
        <CreateDepartmentModal
          form={formDepartment}
          isShow={isCreateDepartmentModal}
          onFinish={(value) => onCreateNewDepartment(value)}
          onCancel={() => {
            setCreateDepartmentModal(false);
            formDepartment.resetFields();
          }}
        />
      </div>
    </>
  );
};
export default CompanysManagement;
